<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text">
        Receitas
      </v-col>
    </v-row>

    <v-row dense v-for="(prescription, index) in prescriptionsPatient" :key="prescription.id">
      <v-col>
        <PrescriptionListItem
          :prescription="prescription"
          :index="index"
          :allowEdit="false"
          :allowDelete="false"
          :forcePrint="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PrescriptionListItem from "@/components/prescription/list/item.vue";

  export default {
    name: "MedicalCertificates",
    props: {
      patient: Object,
    },
    components: {
      PrescriptionListItem,
    },
    apollo: {
      prescriptionsPatient: {
        query: require("@/graphql/prescription/prescriptions_patient.gql"),
        variables() {
          return {
            patientId: this.patient.id,
          };
        },
        pollInterval: 20000,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
